// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.User_pageHeader__tmiaS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.User_pageHeader__tmiaS h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.User_pageHeader__tmiaS .User_right__bOi3B {
  display: flex;
  align-items: center;
  gap: 20px;
}
.User_pageHeader__tmiaS .User_right__bOi3B .User_date__sjDBJ {
  display: flex;
  align-items: center;
  gap: 4px;
}
.User_pageHeader__tmiaS .User_right__bOi3B .User_date__sjDBJ img,
.User_pageHeader__tmiaS .User_right__bOi3B .User_date__sjDBJ svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.User_pageHeader__tmiaS .User_right__bOi3B .User_date__sjDBJ span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.User_pageMain__vxt7W {
  padding: 0 24px;
}
.User_pageMain__vxt7W .User_pageScreen__JVBFL {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 16px 0;
}
@media screen and (max-width: 1420px) {
  .User_pageMain__vxt7W .User_pageScreen__JVBFL.User_sidebarExpand__UyKG6 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1040px) {
  .User_pageMain__vxt7W .User_pageScreen__JVBFL.User_sidebarExpand__UyKG6 {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .User_pageMain__vxt7W .User_pageScreen__JVBFL.User_sidebarExpand__UyKG6 {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .User_pageMain__vxt7W .User_pageScreen__JVBFL {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 870px) {
  .User_pageMain__vxt7W .User_pageScreen__JVBFL {
    grid-template-columns: repeat(1, 1fr);
  }
}

.User_tabContentWrp__wcTRu {
  margin-top: 15px;
}

.User_mainTabs__4VlVi .User_detailsWrp__oaz01 {
  margin-top: 16px;
}
.User_mainTabs__4VlVi .User_topRow__9la3V {
  width: 100%;
  padding-bottom: 12px;
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_rightActions__iH3ny {
  display: flex;
  align-items: center;
  gap: 12px;
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m.User_selected__\\+rGjK img,
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m.User_selected__\\+rGjK svg {
  filter: grayscale(0);
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m.User_selected__\\+rGjK span {
  color: var(--brand);
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m span {
  color: var(--secondary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m img,
.User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_left__a-Wsb .User_tabItem__CpH7m svg {
  width: 16px;
  height: 16px;
  display: block;
  filter: grayscale(1);
}

@media (max-width: 767px) {
  .User_pageHeader__tmiaS {
    padding: 16px;
  }
  .User_pageHeader__tmiaS .User_right__bOi3B {
    gap: 8px;
  }
  .User_pageHeader__tmiaS .User_right__bOi3B button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .User_pageHeader__tmiaS .User_right__bOi3B .User_date__sjDBJ span {
    display: none;
  }
  .User_pageMain__vxt7W {
    padding: 0 16px;
  }
}
@media (max-width: 599px) {
  .User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_rightActions__iH3ny {
    width: 100%;
  }
  .User_mainTabs__4VlVi .User_topRow__9la3V .User_filterBtns__WI78N .User_rightActions__iH3ny button {
    width: 100%;
  }
}
.User_cardView__pDnP7 {
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  overflow: hidden;
}
.User_cardView__pDnP7 .User_cardHead__eT12I {
  background-color: var(--bg1);
  padding: 12px 0 12px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadLeft__9j3fM {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  overflow: hidden;
}
@media screen and (max-width: 450px) {
  .User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadLeft__9j3fM {
    flex-direction: column;
    align-items: start;
    width: 100%;
    max-width: 100%;
  }
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadLeft__9j3fM figure {
  display: flex;
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadLeft__9j3fM figure img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  object-position: center;
  overflow: hidden;
  border: 1px solid var(--border);
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardResponse__M29ot {
  width: fit-content;
}
@media screen and (max-width: 450px) {
  .User_cardView__pDnP7 .User_cardHead__eT12I .User_cardResponse__M29ot {
    position: absolute;
    right: 0;
    top: 16px;
  }
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: calc(100% - 10px);
}
@media screen and (max-width: 450px) {
  .User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt {
    max-width: calc(100% - 12px);
  }
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt h2 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt .User_cardHeadTextSub__64S8j {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt .User_cardHeadTextSub__64S8j p {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding-left: 8px;
  border-left: 1px solid var(--border);
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt .User_cardHeadTextSub__64S8j p:first-child {
  padding-left: 0;
  border-left: 0;
}
.User_cardView__pDnP7 .User_cardHead__eT12I .User_cardHeadText__HhFvt .User_cardHeadTextSub__64S8j p img {
  width: 16px;
  height: 16px;
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX {
  background-color: var(--white);
  border-top: 1px solid var(--border);
  padding: 12px;
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardBody__62tA8 p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardBody__62tA8 span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  display: block;
  margin-top: 4px;
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardBody__62tA8 .User_vendorAndVenue__\\+y4OK {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardBody__62tA8 .User_vendorAndVenue__\\+y4OK button {
  border-radius: 20px;
  font-weight: 400;
  gap: 5px;
  color: var(--secondary-Text);
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardBody__62tA8 .User_vendorAndVenue__\\+y4OK button b {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 450px) {
  .User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB p {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB .User_cardFooterBtn__1ucg8 {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB .User_cardFooterBtn__1ucg8 img {
  filter: brightness(0) invert(1);
}
@media screen and (max-width: 450px) {
  .User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB .User_cardFooterBtn__1ucg8 {
    width: 100%;
  }
  .User_cardView__pDnP7 .User_cardBodyMain__GK1VX .User_cardFooter__GUrBB .User_cardFooterBtn__1ucg8 button {
    width: 100%;
  }
}
.User_cardView__pDnP7 .User_cardStatus__ToITh {
  padding: 8px;
  border-radius: 8px;
  background-color: var(--bg3);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_submitted__zjZMX, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_pending__v8v36 {
  background-color: var(--bg3);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_submitted__zjZMX p, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_pending__v8v36 p {
  color: var(--brand);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_submitted__zjZMX p:before, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_pending__v8v36 p:before {
  background-color: var(--brand);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-review__RSkBS, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-progress__nd6V- {
  background-color: #fff5e9;
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-review__RSkBS p, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-progress__nd6V- p {
  color: var(--warning);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-review__RSkBS p:before, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_in-progress__nd6V- p:before {
  background-color: var(--warning);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_approved__X14xG, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_completed__k69LB {
  background-color: #edf7ee;
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_approved__X14xG p, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_completed__k69LB p {
  color: var(--success);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_approved__X14xG p:before, .User_cardView__pDnP7 .User_cardStatus__ToITh.User_completed__k69LB p:before {
  background-color: var(--success);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_declined__CPFUr {
  background-color: #feeceb;
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_declined__CPFUr p {
  color: var(--error);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh.User_declined__CPFUr p:before {
  background-color: var(--error);
}
.User_cardView__pDnP7 .User_cardStatus__ToITh p {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--brand);
  position: relative;
  padding-left: 8px;
  text-align: center;
  width: fit-content;
  margin: 0 auto;
  text-transform: capitalize;
}
.User_cardView__pDnP7 .User_cardStatus__ToITh p:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--brand);
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/User/index.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,eAAA;AAJD;AAMC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AAJF;AAOG;EADD;IAEE,qCAAA;EAJF;AACF;AAMG;EALD;IAME,qCAAA;EAHF;AACF;AAKG;EATD;IAUE,qCAAA;EAFF;AACF;AAKE;EApBD;IAqBE,qCAAA;EAFD;AACF;AAIE;EAxBD;IAyBE,qCAAA;EADD;AACF;;AAKA;EACC,gBAAA;AAFD;;AAMC;EACC,gBAAA;AAHF;AAMC;EACC,WAAA;EACA,oBAAA;AAJF;AAME;EACC,aAAA;EAEA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AALH;AAOG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AASI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAPL;AAUM;;EAEC,oBAAA;AARP;AAWM;EACC,mBAAA;AATP;AAaK;EACC,4BAAA;EACA,4BAAA;EACA,gBAAA;AAXN;AAcK;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAZN;;AAoBA;EACC;IACC,aAAA;EAjBA;EAmBA;IACC,QAAA;EAjBD;EAmBC;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAjBF;EAqBE;IACC,aAAA;EAnBH;EAyBD;IACC,eAAA;EAvBA;AACF;AA0BA;EAMI;IACC,WAAA;EA7BH;EA+BG;IACC,WAAA;EA7BJ;AACF;AAoCA;EACC,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAlCD;AAoCC;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;AAyCE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EAEA,gBAAA;AAxCH;AA0CG;EARD;IASE,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAvCF;AACF;AAyCG;EACC,aAAA;AAvCJ;AAyCI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;AAvCL;AA4CE;EACC,kBAAA;AA1CH;AA4CG;EAHD;IAKE,kBAAA;IACA,QAAA;IACA,SAAA;EA1CF;AACF;AA6CE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,4BAAA;AA3CH;AA6CG;EAND;IAOE,4BAAA;EA1CF;AACF;AA4CG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EAEA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA3CJ;AA8CG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA5CJ;AA8CI;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,oCAAA;AA7CL;AA+CK;EACC,eAAA;EACA,cAAA;AA7CN;AAgDK;EACC,WAAA;EACA,YAAA;AA9CN;AAqDC;EACC,8BAAA;EACA,mCAAA;EACA,aAAA;AAnDF;AAsDG;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;AApDJ;AAuDG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AArDJ;AAwDG;EACC,aAAA;EACA,eAAA;EACA,SAAA;AAtDJ;AAwDI;EACC,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,4BAAA;AAtDL;AAwDK;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAtDN;AA4DE;EACC,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1DH;AA4DG;EARD;IASE,sBAAA;IACA,SAAA;IACA,kBAAA;EAzDF;AACF;AA2DG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAzDJ;AA4DG;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AA1DJ;AA4DI;EACC,+BAAA;AA1DL;AA6DI;EAXD;IAYE,WAAA;EA1DH;EA4DG;IACC,WAAA;EA1DJ;AACF;AAgEC;EACC,YAAA;EACA,kBAAA;EACA,4BAAA;AA9DF;AAgEE;EAEC,4BAAA;AA/DH;AAiEG;EACC,mBAAA;AA/DJ;AAiEI;EACC,8BAAA;AA/DL;AAoEE;EAEC,yBAAA;AAnEH;AAqEG;EACC,qBAAA;AAnEJ;AAqEI;EACC,gCAAA;AAnEL;AAwEE;EAEC,yBAAA;AAvEH;AAyEG;EACC,qBAAA;AAvEJ;AAyEI;EACC,gCAAA;AAvEL;AA4EE;EACC,yBAAA;AA1EH;AA4EG;EACC,mBAAA;AA1EJ;AA4EI;EACC,8BAAA;AA1EL;AA+EE;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AA7EH;AA+EG;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AA7EJ","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px;\r\n\r\n\t.pageScreen {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(3, 1fr);\r\n\t\tgap: 20px;\r\n\t\tpadding: 16px 0;\r\n\r\n\t\t&.sidebarExpand {\r\n\t\t\t@media screen and (max-width: 1420px) {\r\n\t\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 1040px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 768px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 1200px) {\r\n\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 870px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.tabContentWrp {\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.mainTabs {\r\n\t.detailsWrp {\r\n\t\tmargin-top: 16px;\r\n\t}\r\n\r\n\t.topRow {\r\n\t\twidth: 100%;\r\n\t\tpadding-bottom: 12px;\r\n\r\n\t\t.filterBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\t// flex-wrap: wrap;\r\n\t\t\tgap: 12px;\r\n\t\t\talign-items: center;\r\n\t\t\tflex: 1;\r\n\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t.rightActions {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t.left {\r\n\t\t\t\t.tabItem {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 8px;\r\n\t\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\t\t&.selected {\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\tfilter: grayscale(0);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tfilter: grayscale(1);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageHeader {\r\n\t\tpadding: 16px;\r\n\r\n\t\t.right {\r\n\t\t\tgap: 8px;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 35px;\r\n\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t\ttext-align: center;\r\n\t\t\t}\r\n\r\n\t\t\t.date {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tdisplay: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.pageMain {\r\n\t\tpadding: 0 16px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.mainTabs {\r\n\t\t.topRow {\r\n\t\t\t.filterBtns {\r\n\t\t\t\t// flex-direction: column;\r\n\t\t\t\t// align-items: flex-start;\r\n\t\t\t\t.rightActions {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.cardView {\r\n\tbackground-color: var(--white);\r\n\tborder-radius: 12px;\r\n\tborder: 1px solid var(--border);\r\n\toverflow: hidden;\r\n\r\n\t.cardHead {\r\n\t\tbackground-color: var(--bg1);\r\n\t\tpadding: 12px 0 12px 12px;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tposition: relative;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\t// flex-direction: column;\r\n\t\t\t// gap: 16px;\r\n\t\t}\r\n\r\n\t\t.cardHeadLeft {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: fit-content;\r\n\t\t\t// max-width: calc(100% - 150px);\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: start;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\r\n\t\t\tfigure {\r\n\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 48px;\r\n\t\t\t\t\theight: 48px;\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tobject-position: center;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardResponse {\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t// width: 100%;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tright: 0;\r\n\t\t\t\ttop: 16px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardHeadText {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t\tmax-width: calc(100% - 10px);\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tmax-width: calc(100% - 12px);\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t}\r\n\r\n\t\t\t.cardHeadTextSub {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\tmargin-top: 4px;\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 4px;\r\n\t\t\t\t\tmargin: 0;\r\n\r\n\t\t\t\t\tpadding-left: 8px;\r\n\t\t\t\t\tborder-left: 1px solid var(--border);\r\n\r\n\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t\t\tborder-left: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardBodyMain {\r\n\t\tbackground-color: var(--white);\r\n\t\tborder-top: 1px solid var(--border);\r\n\t\tpadding: 12px;\r\n\r\n\t\t.cardBody {\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tmargin-top: 4px;\r\n\t\t\t}\r\n\r\n\t\t\t.vendorAndVenue {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\tgap: 15px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tborder-radius: 20px;\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tgap: 5px;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\r\n\t\t\t\t\tb {\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardFooter {\r\n\t\t\tmargin-top: 16px;\r\n\t\t\tpadding-top: 16px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 16px;\r\n\t\t\t\talign-items: start;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\r\n\t\t\t.cardFooterBtn {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\tfilter: brightness(0) invert(1);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardStatus {\r\n\t\tpadding: 8px;\r\n\t\tborder-radius: 8px;\r\n\t\tbackground-color: var(--bg3);\r\n\r\n\t\t&.submitted,\r\n\t\t&.pending {\r\n\t\t\tbackground-color: var(--bg3);\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--brand);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.in-review,\r\n\t\t&.in-progress {\r\n\t\t\tbackground-color: #fff5e9;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--warning);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--warning);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.approved,\r\n\t\t&.completed {\r\n\t\t\tbackground-color: #edf7ee;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--success);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--success);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.declined {\r\n\t\t\tbackground-color: #feeceb;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--error);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--error);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tposition: relative;\r\n\t\t\tpadding-left: 8px;\r\n\t\t\ttext-align: center;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\ttext-transform: capitalize;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 50%;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\ttransform: translateY(-50%);\r\n\t\t\t\twidth: 4px;\r\n\t\t\t\theight: 4px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `User_pageHeader__tmiaS`,
	"right": `User_right__bOi3B`,
	"date": `User_date__sjDBJ`,
	"pageMain": `User_pageMain__vxt7W`,
	"pageScreen": `User_pageScreen__JVBFL`,
	"sidebarExpand": `User_sidebarExpand__UyKG6`,
	"tabContentWrp": `User_tabContentWrp__wcTRu`,
	"mainTabs": `User_mainTabs__4VlVi`,
	"detailsWrp": `User_detailsWrp__oaz01`,
	"topRow": `User_topRow__9la3V`,
	"filterBtns": `User_filterBtns__WI78N`,
	"rightActions": `User_rightActions__iH3ny`,
	"left": `User_left__a-Wsb`,
	"tabItem": `User_tabItem__CpH7m`,
	"selected": `User_selected__+rGjK`,
	"cardView": `User_cardView__pDnP7`,
	"cardHead": `User_cardHead__eT12I`,
	"cardHeadLeft": `User_cardHeadLeft__9j3fM`,
	"cardResponse": `User_cardResponse__M29ot`,
	"cardHeadText": `User_cardHeadText__HhFvt`,
	"cardHeadTextSub": `User_cardHeadTextSub__64S8j`,
	"cardBodyMain": `User_cardBodyMain__GK1VX`,
	"cardBody": `User_cardBody__62tA8`,
	"vendorAndVenue": `User_vendorAndVenue__+y4OK`,
	"cardFooter": `User_cardFooter__GUrBB`,
	"cardFooterBtn": `User_cardFooterBtn__1ucg8`,
	"cardStatus": `User_cardStatus__ToITh`,
	"submitted": `User_submitted__zjZMX`,
	"pending": `User_pending__v8v36`,
	"in-review": `User_in-review__RSkBS`,
	"in-progress": `User_in-progress__nd6V-`,
	"approved": `User_approved__X14xG`,
	"completed": `User_completed__k69LB`,
	"declined": `User_declined__CPFUr`
};
export default ___CSS_LOADER_EXPORT___;
